import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Store } from '@ngxs/store';
import { GetBorrowerStatusReasons } from 'app/store/borrower-status-reason/borrower-status-reason.actions';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { StatusOption } from 'app/services/borrower-status/status-options';

interface DialogData {
  selectedOption: StatusOption;
}

@Component({
  selector: 'app-borrower-status-reason-dialog',
  templateUrl: './borrower-status-reason-dialog.component.html',
  styleUrls: ['./borrower-status-reason-dialog.component.scss']
})
export class BorrowerStatusReasonDialogComponent implements OnInit, OnDestroy {
  // data
  reasons$: Observable<any>;
  destroyed$ = new Subject<boolean>();

  // formly
  form: UntypedFormGroup;
  model: {
    reason: null | string;
  };
  fields: FormlyFieldConfig[];

  dncForm = new UntypedFormGroup({});
  dncModel = {
    isNyState: null,
    methods: [],
  };
  dncFields: FormlyFieldConfig[] = [
    {
      key: 'isNyState',
      type: 'radio',
      templateOptions: {
        appearance: 'legacy',
        label: 'Is this borrower\'s business located primarily in NY state?',
        required: true,
        options: [
          { value: 1, label: 'Yes' },
          { value: 0, label: 'No' },
        ],
      }
    },
    {
      key: 'methods',
      type: 'indeterminate-checkbox',
      templateOptions: {
        appearance: 'legacy',
        type: 'array',
        label: 'Which method did the borrower request DNC?',
        required: true,
        options: [
          {
            label: 'SMS',
            value: 'sms',
          },
          {
            label: 'Email',
            value: 'email',
          },
          {
            label: 'Calls',
            value: 'calls',
          },
        ]
      },
    }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private store: Store
  ) { }

  ngOnInit(): void {
    // fetch data
    this.store.dispatch(new GetBorrowerStatusReasons());
    this.reasons$ = this.store
      .select(state => state.borrowerStatusReason.reasons)
      .pipe(
        takeUntil(this.destroyed$),
        map(reasons => reasons
            .filter(reason => reason.status === this.data.selectedOption.value))
      );

    // setup form
    this.form = new UntypedFormGroup({});
    this.model = { reason: null };
    this.fields = [
      {
        key: 'reason',
        type: 'select',
        templateOptions: {
          label: 'Reason',
          required: true,
          options: this.reasons$,
          valueProp: 'reason',
          labelProp: 'reason',
          attributes: {
            'data-cy': 'borrower-status-reason-select',
          }
        }
      }
    ];
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  dncParams() {
    return {
      reason: 'Do Not Contact',
      dncParams: this.dncModel,
    };
  }
}
